import React, { useState, useEffect } from 'react';
import Classes from './Dashboard.module.css';
import Hero1 from './Comp/Hero1';
import RecordTable from './Comp/RecordTable/RecordTable';
import Hero2 from './Comp/Hero2/Hero2';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import backend from '../../../../../api';
import TrialStrip from './Comp/TrialStrip';
import WarningStrip from './Comp/WarningStrip';

export default function Dashboard() {
  const navigateTo = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const userId = user?._id;
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showWarning, setShowWarning] = useState(true);

  async function GetBookings() {
    try {
      const response = await backend.get(`/bookings/mentor?mentorId=${userId}`);
      setBookings(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching bookings:", err);
      setError(err.response?.data?.error || "Failed to load bookings");
      setLoading(false);
    }
  }

  useEffect(() => {
    if (userId && user.role === "mentor") {
      GetBookings();
    } else {
      setError("Only mentees can access this dashboard");
      setLoading(false);
    }
  }, [userId, user.role]);




  console.log("user", user?.mentorProfile?.availability?.dayWiseSettings?.length)

  return (
    <div className={Classes.hero}>

      {user?.mentorProfile?.availability?.dayWiseSettings?.length !== null || undefined ? null : <TrialStrip />}
      {showWarning && <WarningStrip handleCloseWarning={() => setShowWarning(false)} />}

      <Hero1 bookings={bookings} />
      <Hero2 bookings={bookings} />

      <div className="title">
        <div>
          <h4>Upcoming Meetings</h4>
          <h5 onClick={() => navigateTo('/meetings')} style={{ cursor: 'pointer', color: '#e15757' }}>
            View all
          </h5>
        </div>
        <hr />
      </div>
      <RecordTable bookings={bookings} loading={loading} />
    </div >
  );

}